<template>
  <div class="Splash">
    <slot name="overlay"></slot>

    <div class="Page-gutter">
      <div class="Page-header">
        <slot name="header"></slot>

        <div class="Page-caption">
          <slot name="caption"></slot>
        </div>
      </div>
    </div>

    <div class="Splash-content">
      <div class="container">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss">
  .Splash {
    // Display & Box Model
    display: flex;
    flex-direction: column;

    &-content {
      > .container {
        max-width: fetch(container ultrawide);
      }
    }
  }
</style>